const services = [
  {
        icon: "/images/buss.png",
    title: "Local Moving",
    description:
      "NW Trucking of NC has vast experience in local moving - we are the best among the best.",
    href: "/local-moving",
  },
  {
      icon: "/images/buss.png",
    title: "Residential Moving",
    description:
      "Moving your home soon? That is never a problem with NW Trucking of NC!",
    href: "/residential-moving",
  },
  {
      icon: "/images/buss.png",
    title: "Commercial Moving",
    description:
      "Moving your office around Norwood, NC can be an easy experience with our...",
    href: "/commercial-moving",
  },
  {
      icon: "/images/buss.png",
    title: "Apartment Moving",
    description:
      "Let us take care of your apartment move and turn it into smooth sailing. Moving in and out of...",
    href: "/apartment-moving",
  },
  {
      icon: "/images/buss.png",
    title: "Storage In and Out",
    description:
      "Choose your storage unit and we will help you move in – or out of it! If you are planning on moving your items...",
    href: "/storage-in-and-out",
  },
  {
      icon: "/images/buss.png",
    title: "Packing Service",
    description:
      "Packing is never a problem for the packing professionals at NW Trucking of NC!",
    href: "/packing-service",
  },
  {
      icon: "/images/buss.png",
    title: "Packers and Movers",
    description:
      "Your entire move can be placed in the most trustworthy hands and turned into a breeze.",
    href: "/packers-and-movers",
  },
  {
      icon: "/images/buss.png",
    title: "Labor-only Moving",
    description:
      "The worries you may be having for your labor move will be gone in an instant with NW Trucking...",
    href: "/labor-only-moving",
  },
];

export default function ServicesSection() {
  return (
    <section className="w-full px-6 md:px-10 lg:px-20 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 space-y-3">
          <p className="text-[11px] font-semibold tracking-[0.35em] text-foreground-400 uppercase">
            OUR SERVICE
          </p>
          <h2 className="text-[1.75rem] md:text-[2rem] lg:text-[2.4rem] font-extrabold text-foreground-900 leading-tight">
            We&apos;re here to make your{" "}
            <span className="text-accent-500">moving safe</span>
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
            >
              {/* Icon circle – purple bg matching source */}
              <div className="w-16 h-16 rounded-full bg-secondary-100 flex items-center justify-center mb-5">
                <img
                  src={service.icon}
                  alt={service.title}
                  className="w-8 h-8 object-contain"
                  width={32}
                  height={32}
                  onError={(e) => {
                    const target = e.currentTarget as HTMLImageElement;
                    target.style.display = "none";
                    const parent = target.parentElement;
                    if (parent) {
                      const icon = document.createElement("i");
                      icon.className = "ri-truck-line text-xl text-secondary-500";
                      parent.appendChild(icon);
                    }
                  }}
                />
              </div>

              <h3 className="text-[0.95rem] font-bold text-foreground-900 mb-2">
                {service.title}
              </h3>

              <p className="text-sm text-foreground-500 leading-relaxed mb-5">
                {service.description}
              </p>

              <a
                href={service.href}
                className="inline-block px-5 py-1.5 text-xs font-semibold text-secondary-600 border border-secondary-400 rounded-full hover:bg-secondary-500 hover:text-white hover:border-secondary-500 transition-all whitespace-nowrap"
              >
                Read More
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}